import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthProvider";

/** Защищает конструктор: без общей CHM-сессии открывает страницу входа. */
export default function RequireAuth() {
  const { authError, isAuthenticated, isBootstrapping, logout } = useAuth();
  const location = useLocation();

  if (isBootstrapping) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center px-4">
        <p className="font-onest text-sm text-slate-500">Загрузка…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: `${location.pathname}${location.search}${location.hash}`,
        }}
      />
    );
  }

  if (authError) {
    return (
      <div className="mx-auto flex min-h-[60vh] w-full max-w-lg items-center px-4 py-12">
        <div className="w-full rounded-lg border border-amber-200 bg-white p-6 shadow-sm">
          <h1 className="font-onest text-lg font-semibold text-slate-900">
            Вход выполнен, но формы недоступны
          </h1>
          <p className="mt-2 font-onest text-sm leading-relaxed text-slate-600">
            {authError}
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            <button
              type="button"
              className="rounded-md bg-brand-500 px-4 py-2 font-onest text-sm font-medium text-white hover:bg-brand-600"
              onClick={() => window.location.reload()}
            >
              Повторить
            </button>
            <button
              type="button"
              className="rounded-md border border-slate-200 bg-white px-4 py-2 font-onest text-sm font-medium text-slate-700 hover:bg-slate-50"
              onClick={() => void logout()}
            >
              Выйти
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
